module.exports = __webpack_public_path__ + "media/contact_us/contactos_generales-08aeb211.png";